import { useEffect, useRef } from 'react';

export const useEffectIgnoringMount = (fn, dependencies) => {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return fn();
    } else {
      isMountingRef.current = false;
    }
  }, dependencies);
};
